import React from 'react';
import PropTypes from 'prop-types';
import { getText } from 'src/utils/i18n';

const MarketActionShipping = ({ productLogisticsMode = [], i18n }) => {
  if (productLogisticsMode.length === 0) return null;

  const i18nMap = {
    title: getText(i18n, 'mainaction.shipping.title', 'Shipping:'),
    prefix: getText(i18n, 'mainaction.shipping.prefix', 'Support '),
  };
  const textArr = productLogisticsMode.map(item => {
    const itemkey = `mainaction.shipping.${item}`;
    return getText(i18n, itemkey, '');
  });
  return (
    <dl className="ma-brief-item">
      <dt className="market-action-list__dt" title={i18nMap.title}>
        {i18nMap.title}
      </dt>
      <dd className="market-action-list__dd">
        <span>{i18nMap.prefix} </span>
        <span>{textArr.join(' · ')}</span>
      </dd>
    </dl>
  );
};

MarketActionShipping.propTypes = {
  productLogisticsMode: PropTypes.arrayOf(PropTypes.string),
};

export default MarketActionShipping;
